var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-navigation" },
    [
      [
        _c("div", { staticClass: "catsearch" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.catsearch,
                expression: "catsearch"
              }
            ],
            staticClass: "input-unit",
            attrs: {
              type: "search",
              placeholder: _vm.$translate(
                "Snaply5::Template.globalSearchPlaceholderKat"
              )
            },
            domProps: { value: _vm.catsearch },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.catsearch = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.foundcats.length > 0
          ? [
              _c(
                "ul",
                { staticClass: "mainmenu w-100 p-0 m-0 menu-active" },
                _vm._l(_vm.foundcats, function(cat) {
                  return _c("li", { staticClass: "ddown" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase",
                        attrs: { href: cat.details[0].previewUrl }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(cat.details[0].name) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                }),
                0
              )
            ]
          : [
              _c(
                "ul",
                {
                  directives: [{ name: "menu", rawName: "v-menu" }],
                  staticClass: "mainmenu w-100 p-0 m-0 menu-active",
                  attrs: { id: "menu-1" }
                },
                [
                  _vm.breadcrumbs.length == 0
                    ? [
                        _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-uppercase",
                              attrs: { href: _vm.urlNeu }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Snaply5::Template.headerNeu"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-uppercase",
                              attrs: { href: _vm.urlSale }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Snaply5::Template.headerSale"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataContainer1.parent
                    ? _c(
                        "li",
                        {
                          staticClass: "ddown",
                          on: {
                            click: function($event) {
                              return _vm.slideTo(
                                (_vm.dataContainer1.parent &&
                                  _vm.dataContainer1.parent.parent) ||
                                  null,
                                true
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav-direction d-flex align-items-center mHeader"
                            },
                            [
                              _vm.selectedCat
                                ? [
                                    _c("i", {
                                      staticClass: "fa fa-long-arrow-left",
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex-fill text-center" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.selectedCat.details[0].name
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.dataContainer1.categories, function(category) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c(
                        "a",
                        {
                          class: {
                            "text-uppercase": _vm.breadcrumbs.length == 0
                          },
                          attrs: { href: _vm.getCategoryUrl(category.url) }
                        },
                        [_vm._v(_vm._s(category.details[0].name))]
                      ),
                      _vm._v(" "),
                      category.childCount
                        ? _c(
                            "span",
                            {
                              staticClass: "nav-direction",
                              on: {
                                click: function($event) {
                                  return _vm.slideTo(category)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-angle-right",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  }),
                  _vm._v(" "),
                  _vm.dataContainer1.categories[0]
                    ? _vm._l(
                        _vm.dataContainer1.categories[0].siblingCount -
                          _vm.dataContainer1.categories.length,
                        function(number) {
                          return _c("li", { staticClass: "ddown" }, [
                            _c("span", {
                              staticClass: "nav-placeholder m-3",
                              style: { width: Math.random() * 20 + 60 + "%" }
                            })
                          ])
                        }
                      )
                    : _vm.dataContainer1.parent
                    ? _vm._l(_vm.dataContainer1.parent.childCount, function(
                        number
                      ) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" }
                          })
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.breadcrumbs.length == 0
                    ? [
                        _c("li", { staticClass: "ddown" }, [
                          _c("a", { attrs: { href: _vm.urlGutscheine } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Snaply5::Template.headerGutscheine"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.breadcrumbs.length == 0
                    ? [
                        _c("li", [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav-direction d-flex align-items-center mHeader"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-fill text-center" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Snaply5::Template.headerMisc"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c("a", { attrs: { href: _vm.urlStoffWelten } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Snaply5::Template.headerStoffwelten"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c("a", { attrs: { href: _vm.urlShowroom } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Snaply5::Template.headerShowroom"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c("a", { attrs: { href: _vm.urlMagazin } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Snaply5::Template.headerMagazin"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [{ name: "menu", rawName: "v-menu" }],
                  staticClass: "mainmenu w-100 p-0 m-0",
                  attrs: { id: "menu-2" }
                },
                [
                  _vm.breadcrumbs.length == 0
                    ? [
                        _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-uppercase",
                              attrs: { href: _vm.urlNeu }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Snaply5::Template.headerNeu"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c(
                            "a",
                            {
                              staticClass: "text-uppercase",
                              attrs: { href: _vm.urlSale }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Snaply5::Template.headerSale"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataContainer2.parent
                    ? _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              return _vm.slideTo(
                                (_vm.dataContainer2.parent &&
                                  _vm.dataContainer2.parent.parent) ||
                                  null,
                                true
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav-direction d-flex align-items-center mHeader"
                            },
                            [
                              _vm.selectedCat
                                ? [
                                    _c("i", {
                                      staticClass: "fa fa-long-arrow-left",
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex-fill text-center" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.selectedCat.details[0].name
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.dataContainer2.categories, function(category) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c(
                        "a",
                        {
                          class: {
                            "text-uppercase": _vm.breadcrumbs.length == 0
                          },
                          attrs: { href: _vm.getCategoryUrl(category.url) }
                        },
                        [_vm._v(_vm._s(category.details[0].name))]
                      ),
                      _vm._v(" "),
                      category.childCount
                        ? _c(
                            "span",
                            {
                              staticClass: "nav-direction",
                              on: {
                                click: function($event) {
                                  return _vm.slideTo(category)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-lg fa-angle-right",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  }),
                  _vm._v(" "),
                  _vm.dataContainer2.categories[0]
                    ? _vm._l(
                        _vm.dataContainer2.categories[0].siblingCount -
                          _vm.dataContainer2.categories.length,
                        function(number) {
                          return _c("li", { staticClass: "ddown" }, [
                            _c("span", {
                              staticClass: "nav-placeholder m-3",
                              style: { width: Math.random() * 20 + 60 + "%" }
                            })
                          ])
                        }
                      )
                    : _vm.dataContainer2.parent
                    ? _vm._l(_vm.dataContainer2.parent.childCount, function(
                        number
                      ) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" }
                          })
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.breadcrumbs.length == 0
                    ? [
                        _c("li", { staticClass: "ddown" }, [
                          _c("a", { attrs: { href: _vm.urlGutscheine } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Snaply5::Template.headerGutscheine"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.breadcrumbs.length == 0
                    ? [
                        _c("li", [
                          _c(
                            "span",
                            {
                              staticClass:
                                "nav-direction d-flex align-items-center mHeader"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-fill text-center" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Snaply5::Template.headerMisc"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c("a", { attrs: { href: _vm.urlStoffWelten } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Snaply5::Template.headerStoffwelten"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c("a", { attrs: { href: _vm.urlShowroom } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Snaply5::Template.headerShowroom"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "ddown" }, [
                          _c("a", { attrs: { href: _vm.urlMagazin } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Snaply5::Template.headerMagazin"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
      ],
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("div", { staticClass: "d-flex" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.closeNavigation()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ]),
            _vm._v(" "),
            _c("loading-animation")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-fill" }, [
      _c("img", {
        staticStyle: { "max-height": "30px" },
        attrs: {
          alt: "Snaply",
          src:
            "https://cdn02.plentymarkets.com/5rtbqcd0flq3/frontend/Webseite/Logo/snaply-desktop.png"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }